import React, { Component } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  updateEmploymentQuestion,
  getEmploymentQuestion
} from "../../actions/employmentQuestionsActions";
import { connect } from "react-redux";
import Navbar from "../layout/Navbar";
class EditEmploymentQuestion extends Component {
  constructor() {
    super();
    this.state = {
      title: "",
      limit: "",
      errors: {}
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();

    const editEmploymentQuestion = {
      title: this.state.title,
      limit: this.state.limit
    };
    this.props.updateEmploymentQuestion(
      this.props.match.params.id,
      editEmploymentQuestion,
      this.props.history
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
    if (nextProps.employmentQuestion) {
      const employmentQuestion = nextProps.employmentQuestion;
      // Set Component State Field
      this.setState({
        title: employmentQuestion.title,
        limit: employmentQuestion.limit
      });
    }
  }

  componentDidMount() {
    this.props.getEmploymentQuestion(this.props.match.params.id);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { errors } = this.state;

    return (
      <div>
        <Navbar />
        <div className="register">
          <div className="container">
            <div className="row">
              <div className="col-md-8 m-auto">
                <h1 className="display-4 text-center">
                  Edit Employment Question
                </h1>
                <p className="lead text-center">
                  Edit an Employment Quesiton for the applicants.
                </p>
                <form noValidate onSubmit={this.onSubmit}>
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className={classnames("form-control form-control-lg", {
                        "is-invalid": errors.title
                      })}
                      placeholder="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.onChange}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Character Limit for the answer</label>
                    <input
                      type="text"
                      className={classnames("form-control form-control-lg", {
                        "is-invalid": errors.limit
                      })}
                      placeholder="Character Limit for the answer"
                      name="limit"
                      value={this.state.limit}
                      onChange={this.onChange}
                    />
                    {errors.limit && (
                      <div className="invalid-feedback">{errors.limit}</div>
                    )}
                  </div>
                  <button type="submit" className="btn btn-info btn-block mt-4">
                    Edit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EditEmploymentQuestion.propTypes = {
  updateEmploymentQuestion: PropTypes.func.isRequired,
  getEmploymentQuestion: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  employmentQuestion: PropTypes.object
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  employmentQuestion: state.employmentQuestionsData.employmentQuestion
});

export default connect(
  mapStateToProps,
  {
    getEmploymentQuestion,
    updateEmploymentQuestion
  }
)(withRouter(EditEmploymentQuestion));
